import { CartAddEvent } from '@theme/events';

if (!customElements.get('adev-upsell-products')) {
    customElements.define('adev-upsell-products', class adevUpsellProducts extends HTMLElement {
        constructor() {
            super();
        }

        initCarousel(){
            const isCarousel = this.getAttribute('data-carousel') || 'true';

            const carouselWrapper = this.querySelector('[data-adev-upsell-products="products-wrapper"]');
            if (!carouselWrapper) return;
            
            const productsHtmlEl = this.querySelector('[data-adev-upsell-products="products-html"]');
            if (productsHtmlEl) {
                carouselWrapper.innerHTML = productsHtmlEl.innerHTML;
            }

            const hasItems = carouselWrapper.querySelectorAll('[data-adev-upsell="item"]').length > 0;
            if (!hasItems) return;

            this.initProducts();

            this.classList.add('adev--is-ready');
            
            const carouselEl = this.querySelector('[data-adev-upsell-products="products"]');
            if (!carouselEl) return;
            
            if (isCarousel === 'false') return;

            new Flickity(carouselEl, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true
            });

            this.refreshSlider();
        }

        destroySlider(){
            const carouselEl = this.querySelector('[data-adev-upsell-products="products"]');
            const instance = Flickity.data(carouselEl);
            if (instance) {
                instance.resize();
            }
        }

        refreshSlider(){
            const carouselEl = this.querySelector('[data-adev-upsell-products="products"]');
            const instance = Flickity.data(carouselEl);
            if (instance) {
                instance.resize();
            }
        }

        initProducts(){
            this.querySelectorAll('[data-adev-upsell="item"]:not(.adev-init)').forEach(item => {
                console.log(item);
                
                const productId = item.getAttribute('data-product-id') || '';
                const wasPriceEl = item.querySelector('[data-adev-upsell="item-was-price"]');
                const nowPriceEl = item.querySelector('[data-adev-upsell="item-now-price"]');
                const variantsEl = item.querySelector('select[data-adev-upsell="item-variants"]');
                const atcEl = item.querySelector('[data-adev-upsell="item-atc"]');
                const variantsJsonEl = item.querySelector('[data-adev-upsell="item-variants-json"]');
                if (!variantsJsonEl || !variantsEl || !atcEl) return;
                const variantsData = JSON.parse(variantsJsonEl.innerHTML);

                this.products = this.products || {};
                this.products[productId] = this.products[productId] || {};
                this.products[productId]['variantData'] = variantsData;
                this.products[productId]['currentVariant'] = this.products[productId]['variantData'].find((variant) => {
                    return variant.id == variantsEl.value;
                });

                variantsEl.addEventListener('change', (e) => {
                    const value = e.target.value;
                    console.log(value);
                    

                    this.products[productId]['currentVariant'] = this.products[productId]['variantData'].find((variant) => {
                        return variant.id == value;
                    });

				    const currentVariant = this.products[productId]['currentVariant'];
                    console.log(currentVariant);
                    
                    if (currentVariant) {

                        if (currentVariant.compare_at_price > currentVariant.price) {
                            wasPriceEl.style.display = '';
                            wasPriceEl.innerHTML = Shopify.formatMoney(currentVariant.compare_at_price);
                        } else {
                            wasPriceEl.style.display = 'none';
                        }

                        nowPriceEl.innerHTML = Shopify.formatMoney(currentVariant.price);

                        if (currentVariant.available) {
                            atcEl.disabled = false;
                        } else {
                            atcEl.disabled = true;
                        }

                    }

                });


                atcEl.addEventListener('click', (e) => {
                    e.preventDefault();

                    atcEl.classList.add('adev--is-loading');

                    const currentVariant = this.products[productId]['currentVariant'];
                    if (!currentVariant || !currentVariant.available) return;

                    const formData = new FormData();
                    formData.append('id', currentVariant.id);
                    formData.append('quantity', 1);

                    const cartItemsComponents = document.querySelectorAll('cart-items-component');
                    let cartItemComponentsSectionIds = [];
                        cartItemsComponents.forEach((item) => {
                        if (item instanceof HTMLElement && item.dataset.sectionId) {
                            cartItemComponentsSectionIds.push(item.dataset.sectionId);
                        }
                        formData.append('sections', cartItemComponentsSectionIds.join(','));
                    });

                    fetch(Theme.routes.cart_add_url, {
                        method: 'POST',
                        body: formData,
                    })
                    .then(response => response.json())
                    .then(data => {
                        const event = new CustomEvent('adev:cart:updated', { detail: data });
                        document.dispatchEvent(event);
                        atcEl.classList.remove('adev--is-loading');

                        this.dispatchEvent(
                            new CartAddEvent({}, '', {
                                source: 'product-form-component',
                                itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
                                productId: productId,
                                sections: data.sections,
                            })
                        );
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        atcEl.classList.remove('adev--is-loading');
                    });

                });

                item.classList.add('adev-init');

            });
        }

        getProducts(){
            const url = this.getAttribute('data-url') || '';
            const carouselWrapper = this.querySelector('[data-adev-upsell-products="products-wrapper"]');
            if (!carouselWrapper) return;

            fetch(url)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    const sectionHtml = doc.querySelector('.shopify-section');
                    if (!sectionHtml) return;

                    carouselWrapper.innerHTML = sectionHtml.innerHTML;

                    setTimeout(() => {
                        this.initCarousel();
                    }, 100);
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                });
        }

        init(){
            const type = this.getAttribute('data-type') || 'auto';
            
            if (type === 'selected_products') {
                this.initCarousel();
            } else {
                this.getProducts();
            }   
        }

        afterMorph(e) {
            const { node } = e.detail;

            if (node.nodeName === 'CART-DRAWER-COMPONENT') {
                const cartUpsells = document.querySelectorAll('cart-items-component adev-upsell-products');
                
                cartUpsells.forEach((el) => {
                    el.init();
                });
            }
        }

        connectedCallback() {
            this.init();

            document.addEventListener('adev:morph:after', (e) => this.afterMorph(e));

            document.addEventListener('adev:dialog:open', (e) => {
                const dialog = e.detail.dialog;
                if (dialog && dialog.classList.contains('cart-drawer__dialog')) {
                    this.refreshSlider();
                }
            });

            document.addEventListener('adev:dialog:close', (e) => {
                console.log('adev:dialog:close');
                const dialog = e.detail.dialog;
                if (dialog && dialog.classList.contains('cart-drawer__dialog')) {
                    this.refreshSlider();
                }
            });
        }

        disconnectedCallback() {
            this.products = {};

            document.removeEventListener('adev:morph:after', (e) => this.afterMorph(e));
        }


    });
}